import { FieldArray } from 'react-final-form-arrays'
import ParticipantForm from './ParticipantForm'
import { FormattedMessage } from 'react-intl'
import { AdditionalInfo } from './user-forms'

export default function OtherParticipants({
  form,
  values,
  activity,
  extraInfo,
  includedTransfer,
  includedFood,
  includedRental,
}) {
  return (
    <div>
      <p className='section-title'>
        <FormattedMessage
          id='additional_info'
          defaultMessage='Additional information'
        />
      </p>
      <p className='section-subtitle'>
        <FormattedMessage
          id='info_for_dc'
          defaultMessage='Information the dive center needs to confirm your booking'
        />
      </p>
      <div className='shadow-block form-section'>
        <AdditionalInfo
          activity={activity}
          extraInfo={extraInfo}
          includedFood={includedFood}
          includedTransfer={includedTransfer}
        />
        <FieldArray name='trips[0].travelers'>
          {({ fields }) => (
            <div>
              {fields.map((field, index) => (
                <ParticipantForm
                  activity={{ hasRental: includedRental, ...activity }}
                  field={field}
                  key={field}
                  index={index}
                  change={form.change}
                  values={values}
                  isCheckout
                />
              ))}
            </div>
          )}
        </FieldArray>
      </div>
    </div>
  )
}
